/* 🤖 this file was generated by svg-to-ts */
export const svgPinDark: {
    name: "pin-dark";
    data: string;
} = {
    name: "pin-dark",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__pin-dark" viewBox="0 0 21 29"><path fill="#444" d="M11.2,0C5,0,0,5,0,11.2c0,2.6,0.8,5,2.4,7l7.2,9l1.6,2l1.6-2l5.8-7.4l1.2-1.6c1.6-2,2.4-4.4,2.4-7C22.2,5,17.2,0,11.2,0z"/><circle cx="11.2" cy="11.6" r="2" fill="#FFF"/></symbol></svg>`,
};
